var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44324 0.473654C4.7808 -0.15758 3.70638 -0.157932 3.04344 0.472883L2.72659 0.774383C2.12394 0.611269 1.4497 0.75724 0.975163 1.21221C0.274945 1.88361 0.274945 2.97325 0.975163 3.64465L1.35 4.00406V8.57143H0V9.42857H2.92273C2.631 9.70084 2.45 10.0803 2.45 10.5C2.45 11.3284 3.15515 12 4.025 12C4.89485 12 5.6 11.3284 5.6 10.5C5.6 10.0803 5.41901 9.70084 5.12727 9.42857H12.8727C12.581 9.70084 12.4 10.0803 12.4 10.5C12.4 11.3284 13.1051 12 13.975 12C14.8448 12 15.55 11.3284 15.55 10.5C15.55 10.0803 15.369 9.70084 15.0773 9.42857H18V8.57143H16.2V7.23741C16.9748 7.05626 17.55 6.38541 17.55 5.58557C17.55 4.6467 16.7575 3.8856 15.7798 3.8856H6.3495C6.31283 3.8856 6.27759 3.87158 6.25162 3.84668L6.08674 3.68863L6.25253 3.53087C6.91551 2.90001 6.91587 1.87684 6.25333 1.24555L5.44324 0.473654ZM5.45251 3.08048L5.6164 2.92453C5.92771 2.6283 5.92789 2.14791 5.61681 1.85151L4.80672 1.07961C4.49559 0.783126 3.99091 0.782954 3.67956 1.07923L3.52183 1.22931L5.45251 3.08048ZM15.3 8.57143H2.25V4.86698L4.62384 7.14308C4.71901 7.23433 4.84798 7.28558 4.98249 7.28558H15.3V8.57143Z",
    fill: "#007EA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.e578b5214ba5eb82c213e8f6f5501b0b.svg";
export { ForwardRef as ReactComponent };